// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__2ATeF","cell":"styles_cell__K9Atv","noUnderline":"styles_noUnderline__1ul_o","copyLinkText":"styles_copyLinkText__1s08x"};